import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import "./Heading.scss";
export var WeightOptions;
(function (WeightOptions) {
    WeightOptions[WeightOptions["DEFAULT"] = 0] = "DEFAULT";
    WeightOptions[WeightOptions["THIN"] = 1] = "THIN";
})(WeightOptions || (WeightOptions = {}));
export var MarginOptions;
(function (MarginOptions) {
    MarginOptions[MarginOptions["DEFAULT"] = 0] = "DEFAULT";
    MarginOptions[MarginOptions["TOP_ZERO"] = 1] = "TOP_ZERO";
})(MarginOptions || (MarginOptions = {}));
/**
 * @deprecated component has been moved, use ComponentHeading from @jti/ui instead
 */
export const Heading = ({ children, testId, HtmlElement = "div", className, margin = MarginOptions.DEFAULT, weight = WeightOptions.DEFAULT, }) => {
    if (!children)
        return null;
    const classes = classNames({
        heading: true,
        "heading--no-top-margin": margin === MarginOptions.TOP_ZERO,
        "heading--thin": weight === WeightOptions.THIN,
    }, className);
    return (_jsx(HtmlElement, { className: classes, "data-testid": testId, children: children }));
};
//# sourceMappingURL=Heading.js.map